import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { RegionProvider } from './contexts/RegionContext';
import SecureSphereLanding from './pages/SecureSphereLanding';
import SecureSphereLogin from './pages/SecureSphereLogin';
import SecureSphere from './pages/SecureSphere';
import AboutPage from './pages/AboutPage';
import CarriersPage from './pages/CarriersPage';
import CareersPage from './pages/CareersPage';
import DemoPage from './pages/DemoPage';
import AdminPanel from './pages/AdminPanel';
import PresentationPage from './pages/PresentationPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LiveMetricsPage from './pages/LiveMetricsPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  return children;
};

function App() {
  return (
    <RegionProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<SecureSphereLanding />} />
            <Route path="/login" element={<SecureSphereLogin />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/live-metrics" element={<LiveMetricsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/carriers" element={<CarriersPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/presentation" element={<PresentationPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <SecureSphere />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </RegionProvider>
  );
}

export default App;
